import { Market, StrongTeam } from '@nf/types/odds';
import { matchSome } from '@nf/utils-common/fpw/monadic';

const extractLiveTimerMinutes = (matchStatus: string): number => {
	const match = matchStatus.match(/(\d+)'/);
	return match ? parseInt(match[1]) : 0;
};

const getStrongTeam = (betTypes: Array<Market>) => {
	const filteredBetTypes = betTypes
		?.filter(betType => betType.BetTypeId === 1)
		.sort(betType => betType.sort);
	const line = filteredBetTypes?.[0]?.Line ?? 0;
	
	return matchSome(line)
		.on(() => line > 0, () => StrongTeam.Home)
		.on(() => line < 0, () => StrongTeam.Away)
		.otherwise(() => StrongTeam.None);
};

export const matchService = {
	extractLiveTimerMinutes,
	getStrongTeam
};